export default __webpack_public_path__ + "static/media/bell.635f0e7d.webp";